<ion-content class="ion-no-padding login-background">
  <div height-100>
    <ion-img class="login-logo" [src]="logo"></ion-img>
    <ion-content class="bg-defaul bg-linear">
      <div class="complete-content">
        <ion-grid>
          <ion-row>
            <ion-col size="12" margin-auto class="ion-text-center ion-margin">
              <ion-text color="buttonPrimary" margin-auto bold> Parabéns! </ion-text>
            </ion-col>
            <ion-col size="12" margin-auto class="ion-text-center ion-margin">
              <ion-text color="buttonPrimary" margin-auto bold>
                Seu cadastro foi realizado com sucesso.
              </ion-text>
            </ion-col>
            <ion-col size="12" margin-auto>
              <ion-button
                class="ion-margin"
                expand="block"
                color="buttonPrimary"
                routerLink="login"
                queryParamsHandling="merge"
              >
                Voltar para login
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-content>
  </div>
</ion-content>
